import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { AuthenticationService } from '@core/authentication/services';
import { LibComponentsModule } from '@mynexus/mynexus-ui-lib';
import { ButtonModule } from 'primeng/button';

@Component({
    selector: 'app-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss'],
    standalone: true,
    imports: [CommonModule, RouterOutlet, LibComponentsModule, ButtonModule]
})
export class MainComponent {
  userName = this.authenticationService.userName;

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router
  ) { }
  logout(): void {
    this.authenticationService.logout();
  }

  redirectToHomePage() {
    this.router.navigate(['/code-management']);
  }
}
